
/**
 * @copyright 2025 @ DigiNet
 * @author ANHTAI
 * @create 06/03/2025
 * @update 06/03/2025
 * @file src/components/W17/W17F0091
 */

import { Column, CustomRule } from "devextreme-react/data-grid";
import {
    Accordion, AccordionDetails, AccordionSummary, Button, ButtonIcon,
    Card, CardBody,
    Checkbox, Col,
    Dropdown, Image, Modal, ModalBody, ModalFooter, ModalHeader, NumberInput, Popover, PopoverBody, Row, TextInput, Typography
} from 'diginet-core-ui/components';
import Icons from "diginet-core-ui/icons";
import { makeStyles } from "diginet-core-ui/theme";
import PropTypes from "prop-types";
import React, { forwardRef, memo, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userActions from "../../actions/user-actions";
import * as W17F0091Actions from "../../actions/w17/w17F0091/w17F0091-actions";
import Config from "../../config";
import GridContainer from "../common/grid-container/grid-container";
import { Loading } from "../common/loading/loading";
import { browserHistory } from "react-router";
import INVHotModal from "./INVHotModal";

const useStyles = makeStyles((theme) => ({
    ellipsis: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    popAction: {
        minWidth: 196,
        padding: theme.spacing([2, 0, 2, 0])
    },
    btnActionItem: {
        display: 'flex',
        width: '100%',
        justifyContent: 'start',
        color: theme.colors.primary
    },
    btnDownload: {
        position: 'absolute',
        bottom: 0,
        right: 0,
    },
    imageModal: {
        minHeight: 126,
        maxHeight: 570,
        overflowY: 'scroll'
    },
    moneyInputColumn: {
        textAlign: 'right'
    },
    searchDiv: {
        [theme.breakpoints.down("md")]: {
            paddingTop: theme.spacing(4)
        }
    },
    btnSearch: {
        [theme.breakpoints.down("sm")]: {
            marginLeft: '0px !important',
            marginTop: theme.spacing(4)
        }
    },
    orderGrid: {
        minHeight: 380,
        '& .dx-overlay-wrapper.dx-invalid-message.dx-invalid-message-always.dx-datagrid-invalid-message .dx-overlay-content.dx-resizable': {
            top: '108px !important'
        }
    },
    readMore: {
        height: (props) => props?.showMore ? 'auto' : 400,
        overflow: 'hidden'
    },
    cardINV: {
        border: `1px solid ${theme?.colors?.line?.category}`
    },
    discount: {
        position: 'absolute',
        top: 8,
        right: 8,
        color: theme?.colors?.white,
        background: theme?.colors?.danger,
        borderRadius: 4
    },
    discountCol: {
        color: theme?.colors?.white,
        background: theme?.colors?.danger,
        borderRadius: 4
    },
}));

const initialDataMaster = {
    PointsAvailable: null,
    PointsUsed: null,
    PointsRemaining: null,
    DebitAmount: null,
    AdvancePayment: null,
    Balance: null,
    Address: '',
    VATNo: '',
    EmployeeName1: '',
    EmployeeName2: '',
};

const initialOrderState = {
    Notes: '',
    EmployeeID: '',
    TotalCVat: null,
    TotalCAmountPre: null,
    DiscountPoint: null,
    ExpectedPoint: null,
    PricePoint: null,
    UsePoint: null,
    DiscountAmount: null,
    TotalCAmount: null,
};

const FormID = 'W17F0091';
const loadFormList = ['Loadform', 'Addcol', 'Data', 'LoadINVHot'];

const W17F0091 = (props) => {
    const [formLoading, setFormLoading] = useState(false);
    const [openRowInfoModal, setOpenRowInfoModal] = useState(false);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const [openINVHowModal, setOpenINVHowModal] = useState(false);

    const [StrSearch, setStrSearch] = useState('');
    const [dataMaster, setDataMaster] = useState(initialDataMaster);
    const [dynamicCol, setDynamicCol] = useState([]);
    const [dataGrid, setDataGrid] = useState([]);
    const [dataINVHot, setDataINVHot] = useState([]);
    const classes = useStyles();

    const popMoreRef = useRef(null);
    const currentRowClick = useRef(null);
    const dataINVHotInfo = useRef({});
    const isCustomer = Config.getLocalStorage('LOGIN_MODE') === 'customer';

    useEffect(() => {
        if (!isCustomer) return;
        loadForm(loadFormList);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCustomer]);

    const loadForm = async (type, str = StrSearch) => {
        if (Config.typeOf(type, 'array')) {
            const { EmployeeID1 = '', EmployeeID2 = '' } = dataMaster;
            let params = {
                DataTypeID: '',
                StrSearch: str,
                EmployeeID: '',
                QuotationID: '',
                InventoryID: '',
            };
            setFormLoading(true);
            for (let i = 0; i < type.length; i++) {
                params.DataTypeID = type[i];
                if (type === 'Data') params.EmployeeID = `${EmployeeID1};${EmployeeID2}`;
                await props.W17F0091Actions.loadForm(params, (_, data) => {
                    if (data) {
                        switch (type[i]) {
                            case 'Loadform': // Form
                                setDataMaster(data?.[0] || {});
                                break;
                            case 'Addcol': // Column
                                setDynamicCol(data || []);
                                break;
                            case 'Data': // Grid
                                setDataGrid(data || []);
                                break;
                            case 'LoadINVHot': // Grid
                                setDataINVHot(data || []);
                                break;
                            default:
                                break;
                        }
                    }
                });
            }
            setFormLoading(false);
        }
    };

    const onChangeFilter = (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        setStrSearch(value);
        loadForm(['Data'], value);
    };

    const renderCheckBoxCol = (e) => {
        return <Checkbox
            readOnly
            style={{ margin: 'auto' }}
            className={'display_row align-center'}
            checked={e?.value === 1}
        />;
    };

    const renderMaxWidthColum = (e, maxWidth = 300) => { // default max width 300
        const value = e?.value || '';
        return <div title={value} className={classes.ellipsis}
            {...(Config.typeOf(maxWidth, 'number') ? { style: { maxWidth } } : {})} >{value}</div>
    };

    const handleRenderCol = () => {
        let result = [];
        for (let i = 0; i < dynamicCol.length; i++) {
            let objPlus = {};
            let type = 'varchar';
            const { Alignment = 'left', FieldName = '', Caption = '', DataType = '', Visible = true, Width = 150, IsPermanent } = dynamicCol[i] || {};
            if (DataType) type = ['decimal', 'varchar', 'int', 'datetime'].find(item => DataType.search(item) > -1);
            switch (type) {
                case 'decimal': // Number
                    objPlus = {
                        alignment: 'right',
                        dataType: 'number'
                    };
                    break;
                case 'varchar': // String
                    objPlus = {
                        alignment: 'left',
                    };
                    break;
                case 'datetime': // Ngày
                    objPlus = {
                        dataType: 'date',
                        alignment: 'center',
                        format: 'dd/MM/yyyy',
                        editorOptions: { placeholder: 'DD/MM/YYYY' }
                    };
                    break;
                case 'int': // CheckBox / Toggle...
                    objPlus = {
                        alignment: 'center',
                        cellRender: (e) => renderCheckBoxCol(e)
                    };
                    break;
                default:
                    break;
            }
            if (IsPermanent === 1) objPlus = { // PIN Cột
                ...objPlus,
                fixed: true,
                visibleIndex: null,
                fixedPosition: 'left',
            };
            result.push(<Column key={i}
                dataField={FieldName}
                caption={Caption}
                width={Width}
                alignment={Alignment}
                visible={Visible}
                cellRender={(e) => renderMaxWidthColum(e)}
                {...objPlus}
            />)
        }
        return result;
    };

    const renderAction = (e) => {
        return (
            <Popover ref={e => popMoreRef.current = e}
                anchor={<ButtonIcon
                    viewType={'ghost'}
                    name={'Menu'}
                />}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}>
                <PopoverBody className={classes.popAction}>
                    <Button
                        viewType={'text'}
                        color={'primary'}
                        startIcon={'View'}
                        className={classes.btnActionItem}
                        label={Config.lang('Chi_tiet_don_hang')}
                        labelProps={{ style: { textTransform: 'capitalize' } }}
                        onClick={() => {
                            if (popMoreRef.current) popMoreRef.current.close();
                            currentRowClick.current = e?.data || {};
                            setOpenRowInfoModal(true);
                        }}
                    />
                </PopoverBody>
            </Popover>
        );
    };

    const renderGrid = useMemo(() => {
        let column = [];
        if (!Config.isEmpty(dynamicCol)) column = handleRenderCol(dynamicCol);
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }))
        return (
            <GridContainer
                pagerFullScreen={false}
                dataSource={dataSource}
                loading={formLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                elementAttr={{ style: 'max-height: 520px' }}
                onCellClick={(e) => {
                    currentRowClick.current = e?.data || {};
                }} >
                <Column
                    cellRender={(e) => renderAction(e)}
                    caption={Config.lang('Thao_tac')}
                    alignment={'center'}
                    allowEditing={false}
                    allowSorting={false}
                    fixed={true}
                    width={100}
                />
                {column}
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, dynamicCol, formLoading]);

    const handleOpenRowInfoModal = (status = false, isReloadForm = false) => {
        setOpenRowInfoModal(status);
        if (isReloadForm) loadForm(loadFormList); // Load lại Form
    };

    const handleOpenOrderModal = (status = false, isReloadForm = false) => {
        setOpenOrderModal(status);
        if (isReloadForm) loadForm(loadFormList); // Load lại Form
    };

    const handleOpenINVHotModal = (data = {}, status = false, isReloadForm = false) => {
        dataINVHotInfo.current = data;
        setOpenINVHowModal(status);
        if (isReloadForm) loadForm(loadFormList); // Load lại Form
    };

    const handleInfoColSize = (col, isParent = false) => {
        let size = 12;
        const isEmpltyEm2 = Config.isEmpty(dataMaster?.EmployeeID2);
        switch (col) {
            case 'sm':
                if (isParent) {
                    if (isEmpltyEm2) size = 6;
                } else {
                    if (!isEmpltyEm2) size = 6;
                }
                break;
            default:
                break;
        }
        return size
    };

    const renderDataINVHot = useMemo(() => {
        const dataList = dataINVHot.map((item, idx) => {
            const { ImageINVHot = '', InventoryNameHot = '', UnitIDHot = '', IsDiscount } = item || {};
            return (
                <Col xs={6} sm={4} md={2.4} lg={1.71} key={idx}>
                    <Card className={`${classes.cardINV}`} height={380} width={'100%'}>
                        <CardBody className={'height100'}>
                            <div className={'display_row flex-col align-between height100'}>
                                <div>
                                    {IsDiscount === 1 && <div className={'text-right'}><span className={`${classes.discount} pdh1x`}>{Config.lang('Dang_khuyen_mai')}</span></div>}
                                    <div className={'full_w text-center mgt5x'} style={{ maxHeight: 230, overflow: 'hidden' }}><Image width={'100%'} height={'auto'} src={ImageINVHot} /></div>
                                </div>
                                <div>
                                    <Typography type={'h3'} className={'pdv1x'} format={['uppercase']} lineClamp={1} hoverTooltip>{InventoryNameHot}</Typography>
                                    <Typography type={'p3'} color={'secondary'}>{UnitIDHot}</Typography>
                                    <Button
                                        viewType={'outlined'}
                                        color={'primary'}
                                        className={'mgv2x'}
                                        label={Config.lang('Xem_them')}
                                        onClick={() => {
                                            handleOpenINVHotModal(item, true);
                                        }}
                                    />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            )
        });
        return dataList;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataINVHot]);

    const onReadMore = () => {
        browserHistory.push({
            pathname: Config.getRootPath() + 'ListINVhot',
            state: {
                mode: 'view',
                FormID
            }
        });
    };

    if (!isCustomer) return null;
    return (
        <div className='page-container'>
            <Row>
                {openRowInfoModal && <RowInfoModal
                    open={openRowInfoModal}
                    handleOpen={(status) => handleOpenRowInfoModal(status)}
                    dataRow={currentRowClick.current}
                    dataForm={dataMaster}
                    {...props}
                />}
                {openOrderModal && <OrderModal
                    open={openOrderModal}
                    handleOpen={(status, reloadForm) => handleOpenOrderModal(status, reloadForm)}
                    dataForm={dataMaster}
                    handleOpenINVHotModal={handleOpenINVHotModal}
                    {...props}
                />}
                {openINVHowModal && <INVHotModal
                    open={openINVHowModal}
                    dataInfo={dataINVHotInfo.current}
                    handleOpen={(status, reloadForm) => handleOpenINVHotModal({}, status, reloadForm)}
                    dataForm={dataMaster}
                    {...props}
                />}
                <Col xs={12}>
                    <div className={'display_row align-center align-between'}>
                        <div className={'display_row align-center'}><Icons name={"Fire"} color={'dynamic/pumpkin'} height={32} width={32} className={'mgr2x'} /><Typography type={'h1'} format={['uppercase']}>{Config.lang('San_pham_noi_bat')}</Typography></div>
                        <Button
                            viewType={'link'}
                            color={'primary'}
                            endIcon={<Icons name={"Back"} style={{ transform: 'scaleX(-1)' }} />}
                            label={Config.lang('Xem_them')}
                            onClick={onReadMore}
                        />
                    </div>
                </Col>
                {!Config.isEmpty(dataINVHot) && <Col xs={12} className={classes.readMore}>
                    <Row>{renderDataINVHot}</Row>
                </Col>}
                <Col xs={12}>
                    <Accordion expand>
                        <AccordionSummary>{`${Config.lang('Thong_tin_ca_nhan')} ${dataMaster?.CustomerID || ''}`}</AccordionSummary>
                        <AccordionDetails>
                            <Row>
                                <Col xs={12} sm={6} md={4} lg={4} verticalAlign={'start'}>
                                    <TextInput
                                        readOnly
                                        viewType={'outlined'}
                                        value={dataMaster?.VATNo}
                                        label={Config.lang('Ma_so_thue')}
                                    />
                                </Col>
                                <Col xs={12} sm={handleInfoColSize('sm', true)} md={8} lg={4} verticalAlign={'start'}>
                                    <Row>
                                        <Col xs={12} sm={handleInfoColSize('sm')} md={6} lg={12}>
                                            <TextInput
                                                readOnly
                                                viewType={'outlined'}
                                                value={dataMaster?.EmployeeName1}
                                                label={`${Config.lang('Nhan_vien_KD')} 1`}
                                            />
                                        </Col>
                                        {!Config.isEmpty(dataMaster?.EmployeeID2) && <Col xs={12} sm={handleInfoColSize('sm')} md={6} lg={12}>
                                            <TextInput
                                                readOnly
                                                viewType={'outlined'}
                                                value={dataMaster?.EmployeeName2}
                                                label={`${Config.lang('Nhan_vien_KD')} 2`}
                                            /></Col>}
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={8} lg={4} verticalAlign={'start'}>
                                    <TextInput
                                        readOnly
                                        multiline
                                        viewType={'outlined'}
                                        rows={5}
                                        maxRows={5}
                                        value={dataMaster?.Address}
                                        label={Config.lang('Dia_chi')}
                                    />
                                </Col>
                            </Row>
                        </AccordionDetails>
                    </Accordion>
                </Col>
                <Col xs={12}>
                    <Accordion expand>
                        <AccordionSummary>{Config.lang('Diem_tich_luy')}</AccordionSummary>
                        <AccordionDetails>
                            <Row>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <NumberInput
                                        readOnly
                                        viewType={'outlined'}
                                        value={dataMaster?.PointsAvailable}
                                        label={Config.lang('So_diem_kha_dung')} />
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <NumberInput
                                        readOnly
                                        viewType={'outlined'}
                                        value={dataMaster?.PointsUsed}
                                        label={Config.lang('So_diem_da_dung')} />
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <NumberInput
                                        readOnly
                                        viewType={'outlined'}
                                        value={dataMaster?.PointsRemaining}
                                        label={Config.lang('So_diem_con_lai')} />
                                </Col>
                            </Row>
                        </AccordionDetails>
                    </Accordion>
                </Col>
                <Col xs={12}>
                    <Accordion expand>
                        <AccordionSummary>{Config.lang('Thong_tin_cong_no')}</AccordionSummary>
                        <AccordionDetails>
                            <Row>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <NumberInput
                                        readOnly
                                        decimalDigit={2}
                                        thousandSeparator={','}
                                        viewType={'outlined'}
                                        value={dataMaster?.DebitAmount}
                                        label={Config.lang('So_du_no')} />
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <NumberInput
                                        readOnly
                                        decimalDigit={2}
                                        thousandSeparator={','}
                                        viewType={'outlined'}
                                        value={dataMaster?.AdvancePayment}
                                        label={Config.lang('Da_ung_truoc')} />
                                </Col>
                                <Col xs={12} sm={6} md={4} lg={4}>
                                    <NumberInput
                                        readOnly
                                        decimalDigit={2}
                                        thousandSeparator={','}
                                        viewType={'outlined'}
                                        value={dataMaster?.Balance}
                                        label={Config.lang('So_du')} />
                                </Col>
                            </Row>
                        </AccordionDetails>
                    </Accordion>
                </Col>
                <Col xs={12} sm={12} md={6} lg={5}>
                    <Typography type={'h4'}>{Config.lang('Thong_tin_don_hang')}</Typography>
                    <div className={'display_row align-center mgv2x'}>
                        <Button
                            viewType={'outlined'}
                            color={'primary'}
                            startIcon={'AddFilled'}
                            label={Config.lang('Dat_hang')}
                            className={'mgr4x'}
                            onClick={() => handleOpenOrderModal(true)}
                        />
                        <TextInput
                            delayOnChange={700}
                            viewType={'outlined'}
                            value={StrSearch}
                            endIcon={'Search'}
                            style={{ minWidth: 400 }}
                            placeholder={Config.lang('Noi_dung_can_tim')}
                            onChange={(e) => onChangeFilter('StrSearch', e)} />
                    </div>
                </Col>
                <Col xs={12} className={'pdt0'}>{renderGrid}</Col>
            </Row>
        </div>
    );
}

const RowInfoModal = memo(forwardRef((props, _) => {
    const classes = useStyles();
    const { open, handleOpen, dataRow, dataForm } = props;
    const [formLoading, setFormLoading] = useState(false);
    const [dataGrid, setDataGrid] = useState([]);

    useEffect(() => {
        loadForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadForm = () => {
        const { QuotationID = '' } = dataRow;
        const { EmployeeID1 = '', EmployeeID2 = '' } = dataForm;
        const EmployeeID = [EmployeeID1, EmployeeID2].filter(Boolean).join(';');
        let params = {
            DataTypeID: 'DetailInv',
            StrSearch: '',
            EmployeeID,
            QuotationID
        };
        setFormLoading(true);
        props.W17F0091Actions.loadForm(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataGrid(data);
            }
        })
    };

    const renderNumberInputCol = (e) => {
        if (!e) return false;
        let digit = 4;
        const { column: { dataField = "" }, row: { data = {} } } = e || {};
        const decimalValue = data[dataField];
        return <NumberInput
            nonStyle
            readOnly
            disabledNegative
            decimalDigit={digit}
            thousandSeparator={','}
            value={decimalValue}
            inputStyle={{ textAlign: 'right' }}
        />
    };

    const renderGridDetail = useMemo(() => {
        const dataSource = dataGrid.map((item, idx) => ({ ...item, STT: idx }));
        return (
            <GridContainer
                pagerFullScreen={false}
                dataSource={dataSource}
                loading={formLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={30}
                elementAttr={{ style: 'min-height: 280px' }} >
                <Column width={200} caption={Config.lang('Ma_hang')} dataField={'InventoryID'} />
                <Column width={280} caption={Config.lang('Ten_hang')} dataField={'InventoryName'} />
                <Column width={160} caption={Config.lang('Don_vi_tinh')} dataField={'UnitName'} />
                <Column width={180} caption={Config.lang('Don_gia')} dataField={'UnitPrice'} cellRender={renderNumberInputCol} />
                <Column width={130} caption={Config.lang('So_luong')} dataField={'Quantity'} cellRender={renderNumberInputCol} />
                <Column width={200} caption={Config.lang('Thanh_tien')} dataField={'AmountQty'} cellRender={renderNumberInputCol} />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, formLoading]);

    return (
        <>
            {/* Modal List Image */}
            <Modal open={open} size={'lg'} onClose={() => handleOpen(false)}>
                <ModalHeader title={Config.lang('Chi_tiet_don_hang')} />
                <ModalBody className={classes.imageModal}>
                    {formLoading && <Loading />}
                    <Row><Col xs={12}>{renderGridDetail}</Col></Row>
                </ModalBody>
            </Modal>
        </>
    );
}));

const OrderModal = memo(forwardRef((props, _) => {
    const classes = useStyles();
    const { open, handleOpen, handleOpenINVHotModal } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [formLoading, setFormLoading] = useState(false);
    const [gridLoading, setGridLoading] = useState(false);
    const [cboEmployeeLoading, setCboEmployeeLoading] = useState(false);
    const [checkChosenCol, setCheckChosenCol] = useState(false);

    const [chosenNum, setChosenNum] = useState(0);
    const [strSearch, setStrSearch] = useState('');
    const [dataGrid, setDataGrid] = useState([]);
    const [dataCboEmployee, setDataCboEmployee] = useState([]);
    const [dataMaster, _setDataMaster] = useState(initialOrderState);

    const gridRef = useRef(null);
    const chosenNumRef = useRef(null);
    const dataMasterRef = useRef(dataMaster);

    useEffect(() => {
        loadFormOrder(['LoadForm', 'LoadListInv', 'LoadEmp']);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadFormOrder = async (type) => {
        if (Config.typeOf(type, 'array')) {
            let params = {
                DataTypeID: '',
                EmployeeID: '',
                StrSearch: type?.[0] === 'LoadListInv' ? strSearch : '', // Load lưới mới truyền string search
            };
            for (let i = 0; i < type.length; i++) {
                params.DataTypeID = type[i];
                setLoadingAndData(type[i], true);
                await props.W17F0091Actions.loadFormOrder(params, (error, data) => {
                    setLoadingAndData(type[i], false);
                    if (error) {
                        Config.popupCore.show('ERROR', error);
                    } else if (data) {
                        setLoadingAndData(type[i], data);
                    }
                });
            }
        }
    };

    const loadExpectedPoint = (dataDetail = []) => {
        if (Config.isEmpty(dataDetail)) return;
        const params = {
            StrSearch: '',
            EmployeeID: '',
            detail: JSON.stringify(dataDetail)
        };
        setFormLoading(true);
        props.W17F0091Actions.loadExpectedPoint(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                setDataMaster(data);
            }
        });
    };

    const onSave = async () => {
        let detail = [];
        await gridRef.current.instance.saveEditData();
        detail = gridRef.current.instance.option('dataSource') || [];
        if (!Config.isEmpty(detail)) detail = detail.filter(item => !!item?.IsChose); // Dòng có check
        const params = {
            StrSearch: '',
            ...dataMaster,
            detail: JSON.stringify(detail)
        };
        setFormLoading(true);
        props.W17F0091Actions.onSave(params, (error, data) => {
            setFormLoading(false);
            if (error) {
                Config.popupCore.show('ERROR', error);
                return false;
            } else if (data) {
                if (data?.Status === 0) {
                    Config.notify.show('success', Config.lang('Dat_hang_thanh_cong'), 2000);
                    handleOpen && handleOpen(false, true); // Đóng Pop + Reload Form Cha
                } else {
                    if (data?.Message) Config.popupCore.show('INFO', data.Message);
                }
            }
        });
    };

    const setDataMaster = (objData = {}) => {
        dataMasterRef.current = { ...dataMasterRef.current, ...objData };
        _setDataMaster(dataMasterRef.current);
    };

    const onChangeFilter = (e) => {
        const value = e?.value ?? e?.target?.value ?? '';
        setStrSearch(value);
    };

    const setLoadingAndData = (name, data) => {
        const isBol = Config.typeOf(data, 'boolean');
        switch (name) {
            case 'LoadForm': // Master
                isBol ? setFormLoading(data) : setDataMaster(data?.[0] || {});
                break;
            case 'LoadListInv': // Grid
                isBol ? setGridLoading(data) : setDataGrid(data || []);
                break;
            case 'LoadEmp': // DD Emp
                isBol ? setCboEmployeeLoading(data) : setDataCboEmployee(data || [])
                break;
            default:
                break;
        }
    };

    const renderNumberInputCol = (e, mode = 'view') => {
        if (!e) return false;
        let digit = 4;
        const { column: { dataField = "" }, row: { data = {} } } = e || {};
        let decimalValue = data[dataField];
        let objProps = {
            viewType: 'none',
            decimalDigit: digit,
            thousandSeparator: ',',
            inputStyle: { textAlign: 'right' }
        }
        if (dataField === 'CQuantity') objProps = {
            viewType: 'outlined',
            nonStyle: false,
            startIcon: <ButtonIcon name={'Minus'} disabled={mode !== 'edit' || decimalValue <= 0} viewType={'ghost'} onClick={() => {
                const val = decimalValue - 1;
                e.component.cellValue(e.rowIndex, dataField, val);
            }} />,
            endIcon: <ButtonIcon name={'Plus'} disabled={mode !== 'edit'} viewType={'ghost'} onClick={() => {
                const val = decimalValue = decimalValue + 1;
                e.component.cellValue(e.rowIndex, dataField, val);
            }} />,
            inputStyle: { textAlign: 'center' }
        };
        if (mode === 'edit') objProps.onChange = (c) => e.setValue(c.value);
        return <NumberInput
            nonStyle
            disabledNegative
            readOnly={mode !== 'edit'}
            value={decimalValue}
            {...objProps}
        />
    };

    const renderChoseColumn = (e) => {
        return <Checkbox
            style={{ margin: 'auto' }}
            checked={e?.value === 1}
            onChange={(data) => {
                setIsEdit(true);
                const val = !!data?.value;
                dataGrid[e.rowIndex].IsChose = val ? 1 : 0;
                e.component.cellValue(e.rowIndex, 'IsChose', val ? 1 : 0);
                e.component.saveEditData();
                const oldVal = Number(chosenNumRef.current?.innerText) ?? 0;
                setChosenNum(val ? oldVal + 1 : oldVal - 1);
                let dataSource = e.component.option('dataSource') || [];
                if (!Config.isEmpty(dataSource)) dataSource = dataSource.filter(item => !!item?.IsChose);
                if (Config.isEmpty(dataSource)) setIsEdit(false);
            }}
        />;
    };

    const renderImageCol = (e) => {
        return <Image style={{ margin: 'auto' }} height={90} width={'auto'} src={e?.value || ''} />;
    };

    const renderColIsDiscount = (e) => {
        const { data = {} } = e;
        return data?.IsDiscount === 1 ? <div onClick={() => handleOpenINVHotModal && handleOpenINVHotModal(data, true)} className={'pointer'}><span className={`${classes.discountCol} pdh1x`}>{Config.lang('Dang_khuyen_mai')}</span></div> : '';
    };

    const renderGridDetail = useMemo(() => {
        const dataSource = dataGrid.flatMap((item, idx) => checkChosenCol && !item?.IsChose ? [] : [{ ...item, STT: idx }]);
        return (
            <GridContainer
                reference={ref => (gridRef.current = ref)}
                pagerFullScreen={false}
                dataSource={dataSource}
                loading={gridLoading}
                keyExpr={'STT'}
                typePaging={'normal'}
                itemPerPage={10}
                elementAttr={{ style: 'max-height: 460px', class: classes.orderGrid }}
                editing={{
                    mode: 'cell',
                    refreshMode: 'reshape',
                    allowUpdating: true,
                    startEditAction: 'click',
                }}
                onRowUpdating={(e) => {
                    const { newData = {}, oldData = {} } = e;
                    const columnName = (Object.keys(newData))[0];
                    if (['CQuantity'].includes(columnName)) {
                        const { CQuantity = 0 } = newData;
                        const { VatRate = 0, UnitPrice = 0 } = oldData;
                        oldData[columnName] = newData[columnName];
                        // ==============ROW (TiNH TRƯỚC)=================
                        const calCAmountPre = CQuantity * UnitPrice; // Thành tiền trước thuế = số lượng * đơn giá 
                        const calCVat = calCAmountPre * VatRate;  // Tiền thuế = Thành tiền trước thuế * dòng Thuế xuất(%)
                        oldData['CAmountPre'] = calCAmountPre;
                        oldData['CVat'] = calCVat;
                        oldData['CAmount'] = calCAmountPre + calCVat;// Cột Thành tiền = Thành tiền trước thuế  + Tiền thuế  

                        //=================MASTER (TÍNH SAU)=================
                        const { DiscountAmount = 0 } = dataMasterRef.current;
                        let totalCVat = 0; // Tổng tiền thuế = Tổng cột Tiền thuế  
                        let totalCAmountPre = 0; // Tổng tiền tạm tính = Tổng cột Thành tiền trước thuế
                        let changedDataDetail = [];
                        const dataSource = e.component.option("dataSource") || [];
                        for (let i = 0; i < dataSource.length; i++) {
                            const { IsChose, CVat = 0, CAmountPre = 0 } = dataSource[i];
                            if (!!IsChose) {
                                totalCVat += CVat;
                                totalCAmountPre += CAmountPre;
                                const { CQuantity = 0, InventoryID = '', UnitID = '' } = dataSource[i] || {};
                                changedDataDetail.push({ InventoryID, UnitID, Quantity: CQuantity });
                            }
                        }
                        const calTotalCAmount = (totalCAmountPre + totalCVat) - DiscountAmount; // Tổng tiền = (Tổng tiền(tạm tính) + Tổng tiền thuế) - Tổng giảm giá
                        setDataMaster({ TotalCAmountPre: totalCAmountPre, TotalCVat: totalCVat, TotalCAmount: calTotalCAmount });
                        loadExpectedPoint(changedDataDetail); // Tính điểm dự kiến
                    }
                }}
                onRowUpdated={() => {
                    setIsEdit(true);
                }}
                onEditingStart={(e) => {
                    if (!e?.data?.IsChose) e.cancel = true; // Không check không cho Edit
                }}>
                <Column allowEditing={false} width={80} alignment={'center'} dataField={'IsChose'} caption={Config.lang('Chon')} cellRender={renderChoseColumn} />
                <Column allowEditing={false} width={150} alignment={'center'} caption={Config.lang('Anh')} dataField={'InvImage'} cellRender={renderImageCol} />
                <Column allowEditing={false} width={200} caption={Config.lang('Ma_hang')} dataField={'InventoryID'} />
                <Column allowEditing={false} width={280} caption={Config.lang('Ten_hang')} dataField={'InventoryName'} />
                <Column allowEditing={false} width={150} caption={''} dataField={'IsDiscount'} cellRender={renderColIsDiscount} />
                <Column allowEditing={false} width={160} caption={Config.lang('Ton_kho')} dataField={'InvBalance'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')} />
                <Column allowEditing={false} width={120} caption={Config.lang('DVT')} dataField={'UnitID'} />
                <Column allowEditing={false} width={160} caption={Config.lang('Don_gia')} dataField={'UnitPrice'} cellRender={renderNumberInputCol} />
                <Column width={170} dataType={'number'} alignment={'center'} caption={Config.lang('So_luong')} dataField={'CQuantity'} cellRender={renderNumberInputCol} editCellRender={(e) => renderNumberInputCol(e, 'edit')}>
                    <CustomRule
                        message={Config.lang(`%${Config.lang("So_luong")}%_phai_nho_hon_hoac_bang_%${Config.lang('Ton_kho').toLowerCase()}%`)}
                        validationCallback={e => {
                            const { data: { CQuantity = null, InvBalance = null } } = e;
                            return CQuantity <= InvBalance;
                        }}
                    /></Column>
                <Column allowEditing={false} width={180} caption={Config.lang('Thanh_tien_truoc_thue')} dataField={'CAmountPre'} cellRender={renderNumberInputCol} />
                <Column allowEditing={false} width={160} caption={`${Config.lang('Thue_xuat')} %`} dataField={'VatRate'} cellRender={renderNumberInputCol} />
                <Column allowEditing={false} width={180} caption={Config.lang('Tien_thue')} dataField={'CVat'} cellRender={renderNumberInputCol} />
                <Column allowEditing={false} width={180} caption={Config.lang('Thanh_tien')} dataField={'CAmount'} cellRender={renderNumberInputCol} />
            </GridContainer>
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGrid, gridLoading, checkChosenCol]);

    const onChange = async (fieldName, e) => {
        if (Config.isEmpty(fieldName)) return;
        let value = e?.value ?? e?.target?.value ?? '';
        let obPlus = { [fieldName]: value };
        switch (fieldName) {
            case 'chosen':  // Điểm  dự kiện
                if (!!value) {
                    await gridRef.current.instance.saveEditData();
                    const dataSource = gridRef.current.instance.option('dataSource') || [];
                    setDataGrid(dataSource);
                }
                setTimeout(() => setCheckChosenCol(value));
                break;
            case 'UsePoint': // Điểm sử dụng
                if (Config.isEmpty(value)) value = 0;
                const { PricePoint = 0, TotalCVat = 0, TotalCAmountPre = 0 } = dataMaster;
                const discountAmount = (value * PricePoint) ?? 0 // Tổng giảm giá = Điểm sử dụng * giảm giá/điểm 
                const totalCAmount = (TotalCAmountPre + TotalCVat) - discountAmount // Tổng tiền = (Tổng tiền tạm tính + Tổng tiền thuế) – Tổng giảm giá 
                obPlus = { ...obPlus, DiscountAmount: discountAmount, TotalCAmount: totalCAmount };
                break;
            default:
                break;
        }
        setIsEdit(true);
        setDataMaster(obPlus);
    };

    // Modal Order 
    return (
        <Modal open={open} size={'xl'} onClose={() => handleOpen(false)}>
            <ModalHeader title={Config.lang('Dat_hang')} />
            <ModalBody>
                {formLoading && <Loading />}
                <Row>
                    <Col xs={12}>
                        <div className={'wrap align-right align-between'}>
                            <div className={'display_row align-center'}>
                                <Checkbox
                                    className={'mgr1x'}
                                    checked={!!checkChosenCol}
                                    disabled={Config.isEmpty(dataGrid)}
                                    label={Config.lang('Hien_thi_du_lieu_da_chon')}
                                    onChange={e => onChange('chosen', e)}
                                />
                                (<Typography ref={chosenNumRef}>{chosenNum}</Typography>)
                            </div>
                            <div className={`wrap align-center ${classes.searchDiv}`}>
                                <TextInput
                                    style={{ minWidth: 400 }}
                                    viewType={'outlined'}
                                    value={strSearch}
                                    endIcon={'Search'}
                                    onChange={(e) => onChangeFilter(e)}
                                    placeholder={Config.lang('Noi_dung_can_tim')} />
                                <Button
                                    viewType={'outlined'}
                                    color={'primary'}
                                    startIcon={'Search'}
                                    label={Config.lang('Tim_kiem')}
                                    className={`mgl4x ${classes.btnSearch}`}
                                    onClick={() => {
                                        loadFormOrder(['LoadListInv']);
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12}>{renderGridDetail}</Col>
                    <Col xs={12} sm={12} md={3} lg={2.4}>
                        <Dropdown
                            clearAble
                            dataSource={dataCboEmployee || []}
                            valueExpr={'EmployeeID'}
                            displayExpr={'EmployeeName'}
                            viewType={'outlined'}
                            value={dataMaster?.EmployeeID}
                            loading={cboEmployeeLoading}
                            label={Config.lang('Nhan_vien_QL')}
                            onChange={e => onChange('EmployeeID', e)}
                        />
                    </Col>
                    <Col xs={12} sm={12} md={9} lg={9.6}>
                        <TextInput
                            viewType={'outlined'}
                            value={dataMaster?.Notes}
                            label={Config.lang('Ghi_chu')}
                        />
                    </Col>
                    <Col sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }} xs={0} sm={0} md={6} lg={7.2} />
                    <Col xs={12} sm={6} md={3} lg={2.4}>
                        <NumberInput
                            readOnly
                            decimalDigit={2}
                            thousandSeparator={','}
                            viewType={'outlined'}
                            value={dataMaster?.TotalCAmountPre}
                            label={Config.lang('Tong_tien_tam_tinh')} />
                    </Col>
                    <Col xs={12} sm={6} md={3} lg={2.4}>
                        <NumberInput
                            readOnly
                            decimalDigit={2}
                            thousandSeparator={','}
                            viewType={'outlined'}
                            value={dataMaster?.TotalCVat}
                            label={Config.lang('Tong_tien_thue')} />
                    </Col>
                    {dataMaster?.DiscountPoint === 0 && <Col sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }} xs={0} sm={0} md={6} lg={7.2} />}
                    {dataMaster?.DiscountPoint !== 0 && <Col xs={12} sm={6} md={3} lg={2.4}>
                        <NumberInput
                            readOnly
                            decimalDigit={2}
                            thousandSeparator={','}
                            viewType={'outlined'}
                            value={dataMaster?.DiscountPoint}
                            label={Config.lang('Diem_kha_dung')} />
                    </Col>}
                    <Col xs={12} sm={6} md={3} lg={2.4}>
                        <NumberInput
                            readOnly
                            decimalDigit={2}
                            thousandSeparator={','}
                            viewType={'outlined'}
                            value={dataMaster?.ExpectedPoint}
                            onChange={(e) => onChange('ExpectedPoint', e)}
                            label={Config.lang('Diem_du_kien')} />
                    </Col>
                    {dataMaster?.DiscountPoint !== 0 &&
                        <Col xs={12} sm={6} md={3} lg={2.4}>
                            <NumberInput
                                readOnly
                                decimalDigit={2}
                                thousandSeparator={','}
                                viewType={'outlined'}
                                value={dataMaster?.PricePoint}
                                label={Config.lang('Giam_gia_diem')} />
                        </Col>
                    }
                    {dataMaster?.DiscountPoint !== 0 &&
                        <Col xs={12} sm={6} md={3} lg={2.4}>
                            <NumberInput
                                decimalDigit={2}
                                thousandSeparator={','}
                                viewType={'outlined'}
                                value={dataMaster?.UsePoint}
                                onChange={(e) => onChange('UsePoint', e)}
                                label={Config.lang('Diem_su_dung')} />
                        </Col>}
                    <Col xs={12} sm={6} md={3} lg={2.4}>
                        <NumberInput
                            readOnly
                            decimalDigit={2}
                            thousandSeparator={','}
                            viewType={'outlined'}
                            value={dataMaster?.DiscountAmount}
                            label={Config.lang('Tong_giam_gia')} />
                    </Col>
                    <Col sx={{ display: { xs: 'none', sm: 'none', md: 'block', lg: 'block' } }} xs={0} sm={0} md={6} lg={9.6} />
                    <Col xs={12} sm={6} md={3} lg={2.4}>
                        <NumberInput
                            readOnly
                            decimalDigit={2}
                            thousandSeparator={','}
                            viewType={'outlined'}
                            value={dataMaster?.TotalCAmount}
                            label={Config.lang('Tong_tien')} />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button
                    viewType={'filled'}
                    color={'info'}
                    disabled={!isEdit}
                    label={Config.lang('Dat_hang')}
                    onClick={onSave}
                />
            </ModalFooter>
        </Modal>
    );
}));

RowInfoModal.defaultProps = {
    open: false,
    dataForm: {},
    dataRow: {},
};

RowInfoModal.PropTypes = {
    open: PropTypes.bool,
    dataForm: PropTypes.object,
    dataRow: PropTypes.object,
    handleOpen: PropTypes.func
};

OrderModal.defaultProps = RowInfoModal.defaultProps;

OrderModal.PropTypes = RowInfoModal.PropTypes;

export default connect(null, (dispatch) => ({
    W17F0091Actions: bindActionCreators(W17F0091Actions, dispatch),
    userActions: bindActionCreators(userActions, dispatch),
}))(W17F0091);


